import { ReferenceLine } from '@/version-types';

export const ReferenceLineHistoryType = {
    ADD: 'add-reference-line-action',
    CLEAR: 'clear-reference-lines-action',
    DELETE: 'del-reference-line-action',
    LOCK: 'lock-reference-lines-action',
    SHOW: 'show-reference-lines-action',
    UPDATE: 'update-reference-line-action',
};

export type IHistoryAddData = {
    item: ReferenceLine;
};

export type IHistoryClearData = {
    item: ReferenceLine[];
};

export type IHistoryDeleteData = {
    item: ReferenceLine;
};

export type IHistoryLockData = {
    lock: boolean;
};

export type IHistoryShowData = {
    show: boolean;
};

export type IHistoryUpdateData = {
    oldInfo: ReferenceLine;
    newInfo: ReferenceLine;
};
